// local 数据存储管理的工具模块
const USER_KEY = 'user_key'
const CATEGORYID = 'category-id'
const USER_NAME = 'user_name'
const USER_PWD = 'user_pwd'
const USER_EMAIL = 'user_email'
const USER_LOGIN_TYPE = 'user_login_type'

const ADMIN_TOKEN = 'admin_token'
const ADMIN_USER_ID = 'admin_user_id'
const ADMIN_DEVICE_ID = 'admin_device_id'
const ADMIN_PLATFORM_TYPE = 'admin_platform_type'
const ADMIN_OS_VERSION = 'admin_os_version'
const ADMIN_LANG = 'admin_lang'

const CIRCLE_ALIYUN_OSS = 'circle_aliyun_oss'
const JW_TOKEN = 'JwToken'
export default {
  // 保存用户
  saveUser(user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
  },
  // 读取
  getUser() {
    return JSON.parse(localStorage.getItem(USER_KEY) || '{}')
  },
  // 删除
  removeUser() {
    localStorage.removeItem(USER_KEY)
  },
  // 模型类别
  saveCategory(category) {
    localStorage.setItem(CATEGORYID, JSON.stringify(category))
  },
  getCategory() {
    return JSON.parse(localStorage.getItem(CATEGORYID) || '{}')
  },
  // 记住密码
  saveUserName(userName) {
    localStorage.setItem(USER_NAME, userName)
  },
  getUserName() {
    return localStorage.getItem(USER_NAME)
  },
  savePwd(password) {
    localStorage.setItem(USER_PWD, password)
  },
  getPwd() {
    return localStorage.getItem(USER_PWD)
  },
  saveEmail(email) {
    localStorage.setItem(USER_EMAIL, email)
  },
  getEmail() {
    return localStorage.getItem(USER_EMAIL)
  },
  // USER_LOGIN_TYPE
  saveLoginType(password) {
    localStorage.setItem(USER_LOGIN_TYPE, password)
  },
  getLoginType() {
    return localStorage.getItem(USER_LOGIN_TYPE)
  },
  // 删除用户名跟密码
  removeUserName() {
    localStorage.removeItem(USER_NAME)
  },
  removeUserPwd() {
    localStorage.removeItem(USER_PWD)
  },
  removeUserEmail() {
    localStorage.removeItem(USER_EMAIL)
  },
  removeLoginType() {
    localStorage.removeItem(USER_LOGIN_TYPE)
  },
  // token
  saveToken(token) {
    localStorage.setItem(ADMIN_TOKEN, JSON.stringify(token))
  },
  getToken() {
    return JSON.parse(localStorage.getItem(ADMIN_TOKEN))
  },
  removeToken() {
    localStorage.removeItem(ADMIN_TOKEN)
  },
  // userId
  saveUserId(userId) {
    localStorage.setItem(ADMIN_USER_ID, userId)
  },
  getUserId() {
    return localStorage.getItem(ADMIN_USER_ID)
  },
  removeUserId() {
    localStorage.removeItem(ADMIN_USER_ID)
  },

  // DeviceId
  saveDeviceId(deviceId) {
    localStorage.setItem(ADMIN_DEVICE_ID, deviceId)
  },
  getDeviceId() {
    return localStorage.getItem(ADMIN_DEVICE_ID)
  },

  // 设置设备类型
  savePlatformType(platformType) {
    localStorage.setItem(ADMIN_PLATFORM_TYPE, platformType)
  },
  // 读取设备类型
  getPlatformType() {
    return localStorage.getItem(ADMIN_PLATFORM_TYPE)
  },
  // 保存操作系统信息
  saveOsVersion(osVersion) {
    localStorage.setItem(ADMIN_OS_VERSION, osVersion)
  },
  // 读取操作系统信息
  getOsVersion() {
    return localStorage.getItem(ADMIN_OS_VERSION)
  },
  // 保存客户端语言
  saveLang(lang) {
    localStorage.setItem(ADMIN_LANG, lang)
  },
  // 读取客户端语言
  getLang() {
    return localStorage.getItem(ADMIN_LANG)
  },
  saveCircleAliyunOss(oss) {
    localStorage.setItem(CIRCLE_ALIYUN_OSS, JSON.stringify(oss))
  },
  getCircleAliyunOss() {
    return JSON.parse(localStorage.getItem(CIRCLE_ALIYUN_OSS))
  },
  saveJwToken(val) {
    localStorage.setItem(JW_TOKEN, val)
  },
  // 获取jwtToken
  getJwToken() {
    return localStorage.getItem(JW_TOKEN)
  }
}
